import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../../../../config/config.service';
import { ValidacaoParametro } from '../../../../types/ValidacaoParametro.type';

@Injectable({
  providedIn: 'root'
})
export class ValidacaoNotaFiscalService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  getAll() {
    return this.httpClient.get<ValidacaoParametro[]>(
      `${this.configService.getApiUrlRoot()}/notasfiscais/validacao-parametro`
    );
  }

  atualizarStatus(publicId: string, ativo: boolean) {
    return this.httpClient.put<ValidacaoParametro>(
      `${this.configService.getApiUrlRoot()}/notasfiscais/validacao-parametro/${publicId}`,
      { ativo }
    );
  }
}
